// Per-teamspace visibility limits for the Staff role.
//
// DCC asked (and PH later followed) that Staff members see only their own work: their own rate on the
// Members page, only their own time entries in the Time Entries and Calendar
// pages, only their own row in Work Summary, and no Tracking Summary at all.
//
// The rule itself lives ONLY on the server (`web_app/gva_security/policy.py`), which also enforces it
// (queryset filters, a 403 on tracking_summary, blanked `rate` fields). `/users/me/` hands the answer to
// the app as `role_dict[<teamspace name>].restricted_staff`; nothing here re-derives it.

// `teamspaceName` is the name of the currently selected teamspace, as keyed in
// role_dict (see teamspaceIdToNameMap).
const isRestrictedStaff = (user, roleDict, teamspaceName) =>
  !!user && !!teamspaceName && roleDict?.[teamspaceName]?.restricted_staff === true;

// May this person type a time entry's rate in the Edit dialog? Decided on the server
// (policy.py `time_entry_rate.write`) and handed over in role_dict.
const canEditTimeEntryRate = (user, roleDict, teamspaceName) =>
  !!user && !!teamspaceName && roleDict?.[teamspaceName]?.edit_time_entry_rate === true;

// Member.email is the primary key, so it identifies a row exactly — but the
// casing that comes back from the API is not guaranteed to match the session
// user's, so compare folded.
const isSameMember = (member, user) => {
  const a = typeof member?.email === 'string' ? member.email.toLowerCase() : '';
  const b = typeof user?.email === 'string' ? user.email.toLowerCase() : '';
  return !!a && a === b;
};

export { isRestrictedStaff, isSameMember, canEditTimeEntryRate };
